import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import {
  useLazyGetProductQuery,
  useDeleteProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
} from "../../service/product";
import React from "react";
import { PRODUCT_STATUS } from "../../constants/enums";
import { showError, showToast } from "../../constants/toasts";
import usePermission from "../../hooks/usePermission";
import SwitchToggle from "../../components/SwitchToggle";

const ManageProductListing = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  console.log(searchTerm, "dfbdjvfhd");

  const [tab, setTab] = useState(0);
  const [stores, setProducts] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const { isEdit } = usePermission({
    label: "Manage Product Listing",
    page_permission: "isView",
  });

  const [triggerGetProducts] = useLazyGetProductQuery();
  const [deleteProduct] = useDeleteProductMutation();
  const [updateProduct] = useUpdateProductMutation();
  const [triggerGetProductById] = useLazyGetProductByIdQuery();

  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [details, setDetails] = useState<any>(null);

  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectProductId, setRejectProductId] = useState<
    string | number | null
  >(null);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectCustom, setRejectCustom] = useState("");

  const [warnOpen, setWarnOpen] = useState(false);
  const [warnProductId, setWarnProductId] = useState<string | null>(null);
  const [warnMessage, setWarnMessage] = useState("");

  const [reportDetailsOpen, setReportDetailsOpen] = useState(false);
  const [selectedReportedProduct, setSelectedReportedProduct] =
    useState<any>(null);

  const rejectionPresets = [
    "Inappropriate content",
    "Misleading title/description",
    "Policy violation",
    "Duplicate listing",
    "Suspicious / fraudulent post",
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      case "Rejected":
      case "Reported":
        return "error";
      default:
        return "default";
    }
  };

  const mapApiToProducts = (respData: any) => {
    const list = Array.isArray(respData)
      ? respData
      : Array.isArray(respData?.docs)
      ? respData.docs
      : [];
    return list.map((p: any, idx: number) => {
      const statusLabel = p?.isReport
        ? "Reported"
        : p?.status === PRODUCT_STATUS.APPROVED
        ? "Approved"
        : p?.status === PRODUCT_STATUS.REJECTED
        ? "Rejected"
        : "Pending";

      return {
        _id: p?._id || String(idx),
        title: p?.name || p?.title || "-",
        description: p?.description || "-",
        code: p?.referenceId || "-",
        status: statusLabel,
        contactDetails: {
          countryCode: p?.contactDetails?.countryCode || "",
          name: p?.contactDetails?.name || "",
          email: p?.contactDetails?.email || "-",
          phone: p?.contactDetails?.phone || "-",
        },
        postedBy: {
          name: p?.addedByDetails?.fullName || "-",
          _id: p?.addedByDetails?._id || "-",
          email: p?.addedByDetails?.email || "-",
        },
        price: p?.price != null ? Number(p.price) : 0,
        currency: p?.currency || "USD",
        category: p?.category?.name || "-",
        subcategory: p?.subcategory?.name || "-",
        images: Array.isArray(p?.images) ? p.images : [],
        date: p?.createdAt ? new Date(p.createdAt).toLocaleDateString() : "-",
        rejectionReason: p?.rejectionReason,
        reports: p?.reports,
        views: p?.views,
      };
    });
  };

  const fetchProducts = async () => {
    const params: any = {
      page,
      limit,
      search: searchTerm || undefined,
    };
    if (tab === 3) {
      params.isReport = true;
    } else if (tab === 0) {
      params.status = PRODUCT_STATUS.PENDING;
    } else if (tab === 1) {
      params.status = PRODUCT_STATUS.APPROVED;
    } else if (tab === 2) {
      params.status = PRODUCT_STATUS.REJECTED;
    }

    try {
      const res = await triggerGetProducts(params).unwrap();
      const ok =
        res?.code === 200 || res?.statusCode === 200 || res?.status === 200;
      if (ok) {
        setProducts(mapApiToProducts(res?.data?.list));
      } else {
        setProducts([]);
      }
    } catch (e) {
      setProducts([]);
    }
  };

  React.useEffect(() => {
    fetchProducts();
  }, [tab, searchTerm, page, limit]);

  const handleTab = (_: React.SyntheticEvent, v: number) => setTab(v);

  const approveProduct = async (id: any) => {
    try {
      await updateProduct({
        id,
        body: { status: PRODUCT_STATUS.APPROVED },
      }).unwrap();
      fetchProducts();
    } catch {}
  };

  const openReject = (id: string) => {
    setRejectProductId(id);
    setRejectReason("");
    setRejectCustom("");
    setRejectOpen(true);
  };

  const confirmReject = async () => {
    if (!rejectProductId) return;
    const reason = rejectCustom.trim() || rejectReason;
    try {
      await updateProduct({
        id: rejectProductId,
        body: { status: PRODUCT_STATUS.REJECTED, rejectionReason: reason },
      }).unwrap();
      setRejectOpen(false);
      setRejectProductId(null);
      fetchProducts();
    } catch {}
  };

  const openWarn = (id: string) => {
    setWarnProductId(id);
    setWarnMessage("");
    setWarnOpen(true);
  };

  const sendWarn = () => {
    if (!warnProductId) return;
    console.log("Warning sent", { id: warnProductId, message: warnMessage });
    setWarnOpen(false);
    setWarnProductId(null);
  };

  const deleteProductById = async (id: any) => {
    try {
      await deleteProduct({ id }).unwrap();
      fetchProducts();
    } catch {}
  };

  const openReportDetails = (product: any) => {
    setSelectedReportedProduct(product);
    setReportDetailsOpen(true);
  };

  const dismissReport = (productId: string) => {
    setProducts((prev) =>
      prev.map((p) =>
        p._id === productId ? { ...p, status: "Approved", reports: [] } : p
      )
    );
    setReportDetailsOpen(false);
  };

  const filteredProducts = (status: string) =>
    stores.filter((p) => p.status === status);

  const reportProduct = async (id: string) => {
    try {
      await updateProduct({ id, body: { isReported: true } }).unwrap();
      showToast("Product reported successfully");
      fetchProducts();
    } catch (e) {
      showError("Failed to report the product");
    }
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Product Listing</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Product Listing
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search product..."
            />
          </div>
        </div>

        <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
          <Tabs value={tab} onChange={handleTab} className="custom_tabs_links">
            <Tab label={`Pending (${filteredProducts("Pending").length})`} />
            <Tab label={`Approved (${filteredProducts("Approved").length})`} />
            <Tab label={`Rejected (${filteredProducts("Rejected").length})`} />
            <Tab label={`Reported (${filteredProducts("Reported").length})`} />
          </Tabs>
        </Box>

        {/* ---- TABS ---- */}

        {/* Pending */}
        {tab === 0 && (
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Posted By</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProducts("Pending").map((product) => (
                  <TableRow hover key={product._id}>
                    <TableCell>
                      <Box>
                        <img
                          style={{ height: 40, width: 80, objectFit: "cover" }}
                          src={
                            product.images[0] ||
                            "/static/images/placeholder.png"
                          }
                          alt={product.title}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{product.title}</TableCell>
                    <TableCell>
                      <Box
                        component="a"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(
                            `/manage-users/detail/${product.postedBy._id}`
                          );
                        }}
                        className="user_block click_action"
                      >
                        <p>
                          <b>{product?.postedBy?.email || ""}</b>
                          <span>{product?.postedBy?.name || ""}</span>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {product.price} {product.currency}
                    </TableCell>
                    <TableCell>
                      {product.category}
                      <br />
                      <small>{product.subcategory}</small>
                    </TableCell>
                    <TableCell>{product.date}</TableCell>
                    <TableCell>
                      <Chip
                        label={product.status}
                        color={getStatusColor(product.status) as any}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <div className="btn_flex">
                        <Button
                          onClick={() => approveProduct(product._id)}
                          className="btn btn_secondary"
                          size="small"
                        >
                          Approve
                        </Button>
                        <Button
                          onClick={() => openReject(product._id)}
                          className="btn btn_danger"
                          size="small"
                        >
                          Reject
                        </Button>
                        <div className="table_actions v2">
                          <IconButton
                            onClick={() =>
                              navigate(`/manage-products/detail/${product._id}`)
                            }
                            size="small"
                          >
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              navigate(`/manage-products/edit/${product._id}`)
                            }
                            size="small"
                          >
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Edit"
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => deleteProductById(product._id)}
                          >
                            <img
                              src="/static/images/trash2_icon.svg"
                              alt="Deactivate"
                            />
                          </IconButton>
                        </div>
                        {/* <Button
                          onClick={() => reportProduct(product._id)}
                          size="small"
                          variant="outlined"
                          color="warning"
                          sx={{ ml: 1 }}
                        >
                          Report
                        </Button> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Approved */}
        {tab === 1 && (
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Product ID</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Posted By</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Views</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProducts("Approved").map((product) => (
                  <TableRow hover key={product._id}>
                    <TableCell>{product.code}</TableCell>
                    <TableCell>
                      <Box>
                        <img
                          style={{ height: 40, width: 80, objectFit: "cover" }}
                          src={
                            product.images[0] ||
                            "/static/images/placeholder.png"
                          }
                          alt={product.title}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{product.title}</TableCell>
                    <TableCell>
                      <Box className="user_block">
                        <p>
                          <b>{product.postedBy.name}</b>
                          <span>{product.postedBy.email}</span>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {product.price} {product.currency}
                    </TableCell>
                    <TableCell>
                      {product.category}
                      <br />
                      <small>{product.subcategory}</small>
                    </TableCell>
                    <TableCell>{product.date}</TableCell>
                    <TableCell>{product.views || 0}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/detail/${product._id}`)
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/edit/${product._id}`)
                          }
                        >
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton
                          onClick={() => deleteProductById(product._id)}
                        >
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="Deactivate"
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Rejected */}
        {tab === 2 && (
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Product ID</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Posted By</TableCell>
                  <TableCell>Rejection Reason</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProducts("Rejected").map((product) => (
                  <TableRow hover key={product._id}>
                    <TableCell>{product.code}</TableCell>
                    <TableCell>
                      <Box>
                        <img
                          style={{ height: 40, width: 80, objectFit: "cover" }}
                          src={
                            product.images[0] ||
                            "/static/images/placeholder.png"
                          }
                          alt={product.title}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{product.title}</TableCell>
                    <TableCell>
                      <Box className="user_block">
                        <p>
                          <b>{product.postedBy.name}</b>
                          <span>{product.postedBy.email}</span>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {product.rejectionReason || "No reason provided"}
                    </TableCell>
                    <TableCell>{product.date}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/detail/${product._id}`)
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/edit/${product._id}`)
                          }
                        >
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton onClick={() => openReject(product._id)}>
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="Deactivate"
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Reported */}
        {tab === 3 && (
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Product ID</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Posted By</TableCell>
                  <TableCell>Reports Count</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Report Actions</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProducts("Reported").map((product) => (
                  <TableRow hover key={product._id}>
                    <TableCell>{product.code}</TableCell>
                    <TableCell>
                      <Box>
                        <img
                          style={{ height: 40, width: 80, objectFit: "cover" }}
                          src={
                            product.images[0] ||
                            "/static/images/placeholder.png"
                          }
                          alt={product.title}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{product.title}</TableCell>
                    <TableCell>
                      <Box className="user_block">
                        <p>
                          <b>{product.postedBy.name}</b>
                          <span>{product.postedBy.email}</span>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => openReportDetails(product)}
                        size="small"
                      >
                        {product.reports?.length || 0} Reports
                      </Button>
                    </TableCell>
                    <TableCell>{product.date}</TableCell>
                    <TableCell>
                      <div className="btn_flex">
                        <Button
                          onClick={() => openReject(product._id)}
                          className="btn btn_danger"
                          size="small"
                        >
                          Remove
                        </Button>
                        <Button
                          onClick={() => openWarn(product._id)}
                          className="btn btn_warning"
                          size="small"
                        >
                          Warn
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>

      {/* Reject Dialog */}
      <Dialog
        open={rejectOpen}
        onClose={() => setRejectOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold", fontSize: 18 }}>
          Reject Product
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {/* Preset Reasons */}
          <Select
            fullWidth
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            displayEmpty
            sx={{ minHeight: 50 }}
          >
            <MenuItem value="" disabled>
              Select a reason
            </MenuItem>
            {rejectionPresets.map((reason) => (
              <MenuItem key={reason} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </Select>

          {/* Custom Reason */}
          <TextField
            fullWidth
            placeholder="Or enter a custom reason"
            value={rejectCustom}
            onChange={(e) => setRejectCustom(e.target.value)}
            multiline
            minRows={3}
            sx={{ "& .MuiInputBase-root": { padding: "8px 12px" } }}
          />

          {/* Validation error */}
          {!(rejectReason || rejectCustom.trim()) && (
            <Box sx={{ color: "error.main", fontSize: 13 }}>
              Please select or enter a rejection reason
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button
            onClick={() => setRejectOpen(false)}
            variant="outlined"
            sx={{ width: "48%" }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmReject}
            color="error"
            variant="contained"
            sx={{ width: "48%" }}
            disabled={!(rejectReason || rejectCustom.trim())} // <-- disable if no reason
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageProductListing;
